type ClassValue = string | number | null | boolean | undefined

export function cn(...classes: ClassValue[]) {
  return classes.filter(Boolean).join(' ')
}

export function cx(strings: TemplateStringsArray) {
  return strings[0]
    .trim()
    .split(/\r?\n/)
    .reduce((prev, current) => `${prev} ${current.trim()}`, '')
}
